import { Link, useLocation } from 'react-router-dom';
import { BarChart3, ExternalLink, Gift, Sparkles, Users } from 'lucide-react';

export default function SmartResponseSubNav() {
  const location = useLocation();
  const path = location.pathname;

  const tabs = [
    {
      to: '/premieportalen/portal',
      active:
        path === '/premieportalen' ||
        path === '/smartresponse' ||
        path.startsWith('/premieportalen/portal') ||
        path.startsWith('/smartresponse/portal'),
      label: 'Konkurrencer & Portal',
      icon: Gift,
    },
    {
      to: '/premieportalen/leads',
      active: path.startsWith('/premieportalen/leads') || path.startsWith('/smartresponse/leads'),
      label: 'Lead-opsamling',
      icon: Users,
    },
    {
      to: '/premieportalen/campaigns',
      active: path.startsWith('/premieportalen/campaigns') || path.startsWith('/smartresponse/campaigns'),
      label: 'Meta Kampagner',
      icon: Sparkles,
    },
    {
      to: '/premieportalen/meta',
      active: path.startsWith('/premieportalen/meta') || path.startsWith('/smartresponse/meta'),
      label: 'Performance',
      icon: BarChart3,
    },
  ];

  return (
    <div className="mb-6 bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-1.5">
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
                t.active
                  ? 'bg-slate-900 text-white shadow-sm'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`}
            >
              <Icon size={16} />
              <span>{t.label}</span>
            </Link>
          );
        })}
      </div>

      <div className="flex flex-wrap items-center gap-2 text-xs">
        <a
          href="https://premieportal.com/meta-preview"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#1877F2] text-white font-semibold hover:bg-[#166FE5] transition-colors shadow-sm"
        >
          Meta Ad Simulator <ExternalLink size={13} />
        </a>
        <a
          href="https://premieportal.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-emerald-600 text-white font-semibold hover:bg-emerald-700 transition-colors"
        >
          premieportal.com <ExternalLink size={13} />
        </a>
        <a
          href="https://premieportal.com/mobil"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-gray-100 text-gray-700 font-semibold hover:bg-gray-200 transition-colors"
        >
          Mobil-visning <ExternalLink size={13} />
        </a>
      </div>
    </div>
  );
}
